import { FC } from 'react';
import styled from '@emotion/styled';
import { Flex, Text } from '@rebass/emotion';
import { css } from '@emotion/core';
import { useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { rem } from '@app/styles/theme/layout';
import theme from '@app/styles/theme';
import { Button } from '@app/shop/components/Button';
import Triangle from '@app/components/Triangle';
import useLocalizationCountry from '@app/hooks/useLocalizationCountry';

import messages from './Address.messages';

const StoreSwitchModal: FC<{
  country: string;
  onClose: () => void;
}> = ({ country, onClose }) => {
  const { language } = useParams<{ language: string }>();
  const { setLocalizationCountry } = useLocalizationCountry();

  const switchToStore = (country: string) => {
    setLocalizationCountry(country);
    window.location.replace(`/${language}/catalog/`);
  };

  return (
    <Wrapper data-testid="store-switch-modal">
      <Text mb={3} fontFamily={theme.fonts.fontBold} fontSize={rem(28)}>
        <FormattedMessage {...messages.storeChangeTitle} />
      </Text>
      <Text mb={4} lineHeight={rem(24)}>
        <FormattedMessage {...messages.infoCountryChange} />
      </Text>
      <Flex justifyContent="space-between">
        <Button
          data-testid="store-switch-modal-back-button"
          onClick={onClose}
          type="transparent"
          css={css`
            padding-left: 0;
          `}
        >
          <Triangle
            css={css`
              margin: 0 0.5rem 0.1rem 0;
            `}
          />
          <FormattedMessage {...messages.backButton} />
        </Button>
        <Button
          data-testid="store-switch-modal-continue-button"
          onClick={() => switchToStore(country)}
          type="primary"
        >
          <FormattedMessage {...messages.continueButton} />
        </Button>
      </Flex>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: ${theme.colors.blueishGray};
  padding: ${rem(30)};
  border-radius: 2px;
  max-width: ${rem(600)};
`;

export default StoreSwitchModal;
